// 多语言支持 map，会根据 process.env.VUE_APP_SUPPORT_LANG 动态生成
export const localeMap = (() => {
  const map = {
    EN: 'English',
    DE: 'Deutsch',
    FR: 'Français',
    JA: '日本語',
    KO: '한국어',
    'zh-Hant': '繁體中文',
    'zh-Hans': '简体中文',
    ES: 'Español',
    TH: 'ไทย',
    ID: 'Indonesia',
    RU: 'Русский',
    AR: 'العربية',
    VI: 'Tiếng Việt',
    PT: 'Português',
    TR: 'Türkçe',
    IT: 'Italiano',
    NL: 'Nederlands',
    PL: 'Polski',
  }
  let supportLang = []
  try {
    supportLang = JSON.parse(process.env.VUE_APP_SUPPORT_LANG)
  } catch (error) {
    supportLang = Object.keys(map)
  }
  return supportLang.reduce((acc, key) => {
    acc[key] = map[key]
    return acc
  }, {})
})()

export const adyenLocaleMap = {
  EN: 'en-US',
  DE: 'de-DE',
  FR: 'fr-FR',
  JA: 'ja-JP',
  KO: 'ko-KR',
  'zh-Hant': 'zh-TW',
  'zh-Hans': 'zh-CN',
  ES: 'es-ES',
  TH: 'en-US',
  ID: 'en-US',
  RU: 'ru-RU',
  AR: 'en-US',
  VI: 'en-US',
  PT: 'pt-PT',
  TR: 'en-US',
  IT: 'it-IT',
  NL: 'nl-NL',
  PL: 'pl-PL',
}
